/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { makeNiceText } from "utils/formatters";

const getRows = (data, handleOpenMenu) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        type: <SoftBox></SoftBox>,
        id: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="dark"
              fontWeight="bold"
            >
              {item?.id}
            </SoftTypography>
          </SoftBox>
        ),
        nombre: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.nombre ? makeNiceText(item?.nombre) : ""}
            </SoftTypography>
          </SoftBox>
        ),
        apellido: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.apellido ? makeNiceText(item?.apellido) : ""}
            </SoftTypography>
          </SoftBox>
        ),
        dni: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.dni ? item?.dni : ""}
            </SoftTypography>
          </SoftBox>
        ),
        correo: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.correo}
            </SoftTypography>
          </SoftBox>
        ),
        appUsuario: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <SoftTypography
              verticalAlign="text-top"
              variant="caption"
              color="secondary"
              fontWeight="medium"
            >
              {item?.appUsuario ? makeNiceText(item?.appUsuario) : ""}
            </SoftTypography>
          </SoftBox>
        ),
        cuentaCorriente: (
          <SoftBox
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Icon fontSize="small" color={item?.habilitadoCuentaCorriente ? "success" : "error"}>
              {item?.habilitadoCuentaCorriente ? "check_circle" : "cancel"}
            </Icon>
            <SoftTypography
              variant="caption"
              color="secondary"
              fontWeight="medium"
              ml={0.2}
            >
              {item?.esBecado ? makeNiceText("Becado") : ""}
            </SoftTypography>
          </SoftBox>
        ),
        cuentaUpro: (
          <SoftBox
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Icon fontSize="small" color={!item?.cuentaUpro ? "success" : "error"}>
              {!item?.cuentaUpro ? "check_circle" : "cancel"}
            </Icon>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            sx={{
              cursor: "pointer",
            }}
            onClick={(e) => handleOpenMenu(e, item)}
          >
            <Tooltip title="Opciones" placement="top">
              <Icon
                sx={{ color: "primary", cursor: "pointer", mx: 0.5 }}
                fontSize="small"
                onClick={(e) => handleOpenMenu(e, item)}
              >
                more_vert
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
        funcion: (e) => {
          handleOpenMenu(e, item);
        },
      });
    });
  }

  return rows;
};

const columns = [
  { name: "type", desc: " ", align: "left", width: "1%", noOrder: true },
  { name: "id", desc: "ID", align: "left" },
  { name: "apellido", desc: "Apellido", align: "left" },
  { name: "nombre", desc: "Nombre", align: "left" },
  { name: "dni", desc: "DNI", align: "left" },
  { name: "correo", desc: "Correo", align: "left", noOrder: true },
  { name: "appUsuario", desc: "Sistema", align: "center" },
  { name: "cuentaCorriente", desc: "Cuenta corriente", align: "center" },
  { name: "cuentaUpro", desc: "Cuenta funcionario", align: "center" },
  { name: "accion", desc: "Acciones", align: "right", noOrder: true },
];

export default { columns, getRows };
